// LandingPage.js
import React from 'react';
import '../../styles/LandingPage.scss';
import Header from './Header';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header>
        <div className='header-child menu-title'>
            {/* <h1>Benvenuto al CosyHole</h1> */}
            {/* <p>Preparati a esplorare il nostro delizioso menù di pizze e birre artigianali.</p> */}
            <div className="loader"></div>
            <p>Caricamento in corso...</p>
        </div>
      </Header>
    </div>
  );
};

export default LandingPage;
